(function () {
  'use strict';

  var contactUsTier = false;

  function getEl(id) {
    return document.getElementById(id);
  }

  function get_calculation_result(selected_value) {
    var titleEl = getEl('variant_title');
    var priceEl = getEl('variant_price');
    var idEl = getEl('variant_id');
    if (!titleEl || !priceEl || !idEl) return 0;

    var variant_title = titleEl.value;
    var variant_price = priceEl.value;
    var variant_id = idEl.value;
    if (!variant_title || !variant_price) return 0;

    var titles = variant_title.split('@#@');
    var prices = variant_price.split('@#@');
    var ids = variant_id.split('@#@');

    var selected_total_price = 0;
    var selected_variant_id = 0;
    contactUsTier = false;

    titles.forEach(function (value, key) {
      if (value === '') return;
      var parts = value.split('-');
      var fromlimit = parts[0] !== undefined ? parseInt(parts[0].replace(/[^0-9.]/g, ''), 10) : 0;
      var tolimit = parts[1] !== undefined ? parseInt(parts[1].replace(/[^0-9.]/g, ''), 10) : 0;

      var matched = false;
      if (fromlimit > 0 && tolimit > 0) {
        if (selected_value >= fromlimit && selected_value <= tolimit) matched = true;
      } else if (fromlimit === 0 && tolimit > 0) {
        if (selected_value <= tolimit) matched = true;
      } else if (fromlimit >= 0 && tolimit === 0) {
        if (selected_value >= fromlimit) matched = true;
      }

      if (matched) {
        selected_total_price = parseInt(prices[key], 10);
        selected_variant_id = ids[key];
        contactUsTier = selected_total_price === 0;
      }
    });

    var variantIdInput = getEl('selected_variant_id');
    if (variantIdInput) variantIdInput.value = selected_variant_id;

    return selected_total_price;
  }

  function setAtcState(isContact) {
    var atcLink = document.querySelector('.custom-atc-link');
    if (!atcLink) return;
    if (isContact) {
      atcLink.classList.add('custom-atc-link--contact');
      atcLink.setAttribute('aria-disabled', 'true');
    } else {
      atcLink.classList.remove('custom-atc-link--contact');
      atcLink.removeAttribute('aria-disabled');
    }
  }

  function showAlert(message) {
    if (getEl('product-qty-alert')) return;
    var el = document.createElement('div');
    el.id = 'product-qty-alert';
    el.innerHTML =
      '<div class="product-qty-alert__box">' +
        '<p class="product-qty-alert__message">' + message + '</p>' +
        '<button id="product-qty-alert-close">Ok</button>' +
      '</div>';
    document.body.appendChild(el);
    getEl('product-qty-alert-close').addEventListener('click', function () {
      var alertEl = getEl('product-qty-alert');
      if (alertEl) alertEl.remove();
    });
  }

  function submitCart() {
    if (contactUsTier) return false;

    var variantIdInput = getEl('selected_variant_id');
    if (!variantIdInput || variantIdInput.value == 0 || variantIdInput.value === '') {
      showAlert('Please provide minimum 1 Quantity to add to cart');
      return false;
    }

    fetch('/cart.js', { method: 'GET', headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var hasBundle = cart.items.some(function (item) {
          return item.product_id == 7174189449264;
        });
        if (hasBundle) {
          var popup = getEl('popuptoshow');
          if (popup) popup.style.display = 'flex';
        } else {
          var atcLink = document.querySelector('.custom-atc-link');
          if (atcLink) atcLink.classList.add('custom-atc-link--loading');

          var form = document.querySelector('form[action*="/cart/add"]');
          var formData = form ? new FormData(form) : new FormData();
          fetch('/cart/add.js', { method: 'POST', body: formData })
            .then(function (res) {
              if (!res.ok) throw new Error('Cart add failed');
              return res.json();
            })
            .then(function (data) {
              if (atcLink) atcLink.classList.remove('custom-atc-link--loading');
              showCartToast(data);
              updateCartCount();
            })
            .catch(function (err) {
              if (atcLink) atcLink.classList.remove('custom-atc-link--loading');
              console.error(err);
            });
        }
      });
  }

  function showCartToast(item) {
    if (window.cartToast) window.cartToast.show(item);
  }

  function updateCartCount() {
    var countEl = document.querySelector('.header__cart-count');
    if (!countEl) return;
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { countEl.textContent = cart.item_count; })
      .catch(function () {});
  }

  document.addEventListener('DOMContentLoaded', function () {
    // Sync checkout_count{N} → count-{N} property inputs
    for (var i = 1; i <= 5; i++) {
      (function (index) {
        var countInput = getEl('checkout_count' + index);
        var propInput = getEl('count-' + index);
        if (countInput && propInput) {
          countInput.addEventListener('input', function () {
            propInput.value = this.value;
          });
        }
      })(i);
    }

    // Recalculate totals on any .checkout_count change
    document.addEventListener('input', function (e) {
      if (!e.target.classList.contains('checkout_count')) return;

      var val = e.target.value;
      if (val !== '' && isNaN(val)) {
        e.target.value = '';
        alert('Please provide valid number');
        return;
      }

      var total = 0;
      document.querySelectorAll('.checkout_count').forEach(function (el) {
        var v = parseInt(el.value, 10);
        if (!isNaN(v) && v > 0) total += v;
      });

      var unitPriceCents = get_calculation_result(total);

      var totalQtyEl = getEl('total_quantity');
      var totalPPUEl = getEl('total_price_per_unit');
      var totalPriceEl = getEl('total_price');
      var selectedQtyEl = getEl('selected_quantity');

      if (totalQtyEl) totalQtyEl.textContent = total;
      if (selectedQtyEl) selectedQtyEl.value = total;

      if (contactUsTier && total > 0) {
        var contactLink = '<a href="mailto:info@happetite.net" style="color:var(--color-primary);font-weight:600;text-decoration:none;">Contact us</a>';
        if (totalPPUEl) totalPPUEl.innerHTML = contactLink;
        if (totalPriceEl) totalPriceEl.innerHTML = contactLink;
        setAtcState(true);
      } else {
        var unitPrice = unitPriceCents > 0 ? unitPriceCents / 100 : 0;
        var totalPrice = total * unitPrice;
        if (totalPPUEl) totalPPUEl.textContent = '$' + unitPrice.toFixed(2);
        if (totalPriceEl) totalPriceEl.textContent = '$' + totalPrice.toFixed(2);
        setAtcState(false);
      }
    });

    // ATC button click
    document.addEventListener('click', function (e) {
      var atcLink = e.target.closest('.custom-atc-link');
      if (atcLink) {
        e.preventDefault();
        submitCart();
      }
    });

    // Bundle conflict popup close
    document.addEventListener('click', function (e) {
      if (e.target.id === 'popup-close' || e.target.closest('#popup-close')) {
        var popup = getEl('popuptoshow');
        if (popup) popup.style.display = 'none';
      }
    });
  });
})();
